// extracted by mini-css-extract-plugin
export default {"Root":"AttributeSelector_Root__tr7zO"};